import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
	AccountEntityType,
	INewAccount,
	INewBankAccount,
	INewUser,
	newAccountsSteps,
} from 'constants/new_accounts.constants';
import { initialMessage, userMessage } from 'constants/ui.constants';
import { countryId } from 'constants/user.constants';
import _ from 'lodash';

type isDirty = {
	dirty: boolean;
	type?: newAccountsSteps;
};
interface INewAccountsState {
	accountsInProcess?: any;
	newAccount?: Partial<INewAccount>;
	newUsers?: Record<string, INewUser>;
	newUser?: INewUser;
	newBankAccount?: INewBankAccount;
	newBankAccounts?: Record<string, INewBankAccount>;
	isDirty: isDirty;
	isLoading?: boolean;
	finishProcess: boolean;
	isUserAddedSuccesfully: boolean;
	error: userMessage;
	activeStepIdx: number;
}

const initialState: INewAccountsState = {
	newAccount: {},
	newUsers: {},
	newUser: {},
	newBankAccounts: {},
	newBankAccount: {},
	isLoading: false,
	accountsInProcess: [],
	finishProcess: false,
	isUserAddedSuccesfully: false,
	error: initialMessage,
	activeStepIdx: 1,
	isDirty: {
		dirty: false,
	},
};

export const NewAccountsSlice = createSlice({
	name: 'NewAccounts',
	initialState,
	reducers: {
		setNewAccount: (state, { payload }) => {
			state.newAccount = payload;
		},
		setNewAccountById: (state, { payload }) => {
			//state.newAccount = payload;
		},
		resetNewAccount: (state) => {
			state.newAccount = {
				entityType: AccountEntityType.COMPANY,
				countryId: countryId,
				dealerId: null,
				customerSuccessManagerId: null,
				agentId: null,
				leadId: null,
				allowedPaymentCategoryIds: [],
				expectedPaymentCountryIds: [],
			};
			state.newUsers = {};
			state.newUser = {};
			state.newBankAccounts = {};
			state.newBankAccount = {};
			state.activeStepIdx = 1;
			state.finishProcess = false;
			state.isDirty = {
				dirty: false,
			};
		},
		setActiveStepIdx: (state, { payload }) => {
			state.activeStepIdx = payload;
		},
		setAccountsInProcess: (state, { payload }) => {
			state.accountsInProcess = payload;
		},
		setNewUser: (state, { payload }) => {
			state.newUser = payload;
		},
		setNewUsers: (state, { payload }) => {
			state.newUsers = { ...state.newUsers, ...payload };
		},
		initialNewUsers: (state, { payload }) => {
			state.newUsers = payload;
		},
		setNewBankAccount: (state, { payload }) => {
			state.newBankAccount = payload;
		},
		setNewBankAccounts: (state, { payload }) => {
			state.newBankAccounts = { ...state.newBankAccounts, ...payload };
		},
		initialNewBankAccounts: (state, { payload }) => {
			state.newBankAccounts = payload;
		},
		setNewAccountId: (state, { payload }) => {
			state.newAccount = { ...state.newAccount, id: payload };
		},
		setFinishProcess: (state, { payload }) => {
			state.finishProcess = payload;
		},
		setUserAddedSuccesfully: (state, { payload }) => {
			state.isUserAddedSuccesfully = payload;
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setLoading: (state, { payload }) => {
			state.isLoading = payload;
		},
		setIsDirty: (state, { payload }) => {
			state.isDirty = payload;
		},
	},
});

export const getIsLoading = (state: any) => {
	return state.newAccount.isLoading;
};

export const getNewAccount = (state: any) => {
	return state.newAccount.newAccount;
};

export const getNewUsers = (state: any) => {
	return state.newAccount.newUsers;
};

export const getNewUser = (state: any) => {
	return state.newAccount.newUser;
};

export const getAccountsInProcess = (state: any) => {
	return state.newAccount.accountsInProcess;
};

export const getNewBankAccounts = (state: any) => {
	return state.newAccount.newBankAccounts;
};

export const getNewBankAccount = (state: any) => {
	return state.newAccount.newBankAccount;
};

export const getFinishProcess = (state: any) => {
	return state.newAccount.finishProcess;
};
export const getUserAddedSuccesfully = (state: any) => {
	return state.newAccount.isUserAddedSuccesfully;
};

export const getError = (state: any) => {
	return state.newAccount.error;
};
export const getLoading = (state: any) => {
	return state.newAccount.isLoading;
};
export const getActiveStepIdx = (state: any) => {
	return state.newAccount.activeStepIdx;
};
export const getIsDirty = (state: any) => {
	return state.newAccount.isDirty;
};

export const {
	resetNewAccount,
	setNewAccount,
	setNewUser,
	setNewUsers,
	initialNewUsers,
	setNewBankAccounts,
	setNewBankAccount,
	initialNewBankAccounts,
	setAccountsInProcess,
	setNewAccountById,
	setNewAccountId,
	setFinishProcess,
	setUserAddedSuccesfully,
	setError,
	setLoading,
	setActiveStepIdx,
	setIsDirty,
} = NewAccountsSlice.actions;

export default NewAccountsSlice.reducer;
